import { render, staticRenderFns } from "./saleDetailReport.vue?vue&type=template&id=521845b4&"
import script from "./saleDetailReport.vue?vue&type=script&lang=js&"
export * from "./saleDetailReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports